export function splitIntoParagraphs(text) {
  const t = (text || '').trim();
  if (!t) return [];
  if (t.includes('|||')) return t.split('|||').map((s) => s.trim()).filter(Boolean);
  if (t.includes('\n')) return t.split(/\n+/).filter(Boolean);
  return [t];
}

export function formatDescriptionPlainText(text) {
  return splitIntoParagraphs(text).join('\n\n');
}
